import React, { Fragment, useCallback, useEffect, useRef, useState } from "react";
import CameraComponent from "./camera";
import { ID_BACK, ID_FRONT, SELFIE } from "../../Apps/checkedInScreens/idVerification/verifyIdentity";
import { PicturePreview } from "./picturePreview";
import { Alert, Text, View } from "react-native";
import SelfieOverlay from "./selfieOverlay";
import IdOverlay from "./idOverlay";




const AccessingCamera = (props) => {

    const { cameraType = 'back', pictureType, previewImageUri, detectLiveliness, hidePicturePreview = false, handleImageSave, handleCloseCamera } = props || {};
    const cameraCompRef = useRef(null);

    const [tipIndex, setTipIndex] = useState(0);
    const [startSelfieAnimation, setStartSelfieAnimation] = useState(false);
    const [imageInfo, setImageInfo] = useState({
        detectLiveliness: detectLiveliness,
        numberOfMultipleImages: 8,
        imageUri: "",
        imageUriArr: []
    })

    const [picturePreviewConfig, setShowPicturePreviewConfig] = useState({
        showPicturePreview: false,
        imageUri: null,
    });

    const handleShowPicturePreview = (imageUri) => [
        setShowPicturePreviewConfig({showPicturePreview: true, imageUri: imageUri})
    ]

    const handleClosePicturePreview = () => {
        setImageInfo({...imageInfo, imageUri: "", imageUriArr: []});
        setShowPicturePreviewConfig({showPicturePreview: false, imageUri: ""});
    }

    const handleNextPicturePreview = () => {
        handleImageCapture(picturePreviewConfig.imageUri, true);
    }

    const handleImageCapture = (imageUri, previewdone = false) => {

        setImageInfo(prevState => {
            
            if (!prevState.detectLiveliness || prevState.imageUriArr.length >= prevState.numberOfMultipleImages) {
                setStartSelfieAnimation(false);
                setTipIndex(0);

                if(!previewdone && !hidePicturePreview){
                    handleShowPicturePreview(imageUri);
                    return prevState;
                }
                return { ...prevState, imageUri };
            }


            setStartSelfieAnimation(true);
    
            const imageCount = prevState.imageUriArr.length;
    
            const addImageAndCapture = () => {

                console.log(imageCount);
                console.log(prevState.imageUriArr)
                console.log("time: " + new Date().getSeconds());

                setImageInfo(prevState => ({
                    ...prevState,
                    imageUriArr: [...prevState.imageUriArr, imageUri]
                }));

                setTimeout(() => {
                    captureImage();
                }, 0);
            };


            if (imageCount < 3) {
                // left
                setTimeout(() => {
                    setTipIndex(1);
                    addImageAndCapture();
                }, 1000)
            } else if (imageCount == 3) {
                // front
                setTipIndex(10);

                // right
                setTimeout(() => {
                    setTipIndex(2);
                }, 2000)
                setTimeout(() => {
                    addImageAndCapture();
                }, 2500)
            } else if (imageCount >= 4 && imageCount < 6) {
                // right
                setTipIndex(2);
                setTimeout(() => {
                    addImageAndCapture();
                }, 1000)
            } else if (imageCount == 6) {

                setTipIndex(10);
                // front
                setTimeout(() => {
                    setTipIndex(3);
                }, 2000)
                setTimeout(() => {
                    addImageAndCapture();
                }, 2500)
            }else if (imageCount == 7) {
                // front
                
                setTimeout(() => {
                    setTipIndex(10);

                    setTimeout(() => {
                        addImageAndCapture();
                    }, 1500);
                }, 3000)
            }

            return prevState;
        })
    }

    const captureImage = () => {
        cameraCompRef.current?.takePicture(); // Call the exposed takePicture method
    };


    




    const handleNext = () => {

        {
            // React-Native: local path,
            // React-Native Web: base64

        }
        handleImageSave({imageUri: imageInfo.imageUri, imageUriArr: imageInfo.imageUriArr});
        handleCloseCamera();
    }

    useEffect(() => {
        if(imageInfo.imageUri){
            handleNext();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[imageInfo.imageUri])

    useEffect(() => {
        if(previewImageUri && !detectLiveliness) handleShowPicturePreview(previewImageUri);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    return picturePreviewConfig.showPicturePreview ? (
        <PicturePreview
          pictureUri={picturePreviewConfig.imageUri}
          imageDescrption={
            pictureType == ID_BACK || pictureType == ID_FRONT
              ? "Are the details all clear and readable?"
              : "Do you want to use this photo?"
          }
          handleNextPicturePreview={handleNextPicturePreview}
          handleClosePicturePreview={handleClosePicturePreview}
          handleGoBack={handleCloseCamera}
        />
      ) : (
      <>
        <CameraComponent
          ref={cameraCompRef}
          cameraType={cameraType}
          handleImageCapture={handleImageCapture}
          handleCloseCamera={handleCloseCamera}
          pictureType={pictureType}
        />

        {(pictureType == ID_BACK || pictureType == ID_FRONT) && <IdOverlay />}
        {pictureType == SELFIE && <SelfieOverlay tipIndex={tipIndex} startAnimation={startSelfieAnimation} />}
        </>
      )
}


export default AccessingCamera;